import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { GenericDocCustomerReviewReplyHistoryModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiVisa, BasicApiResponseModel } from '../../shared';


@Injectable({
    providedIn: 'root'
})
export class CustomerReviewReplyHistoryService extends BaseApiTemplateService<GenericDocCustomerReviewReplyHistoryModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-review-reply-history/' + Core2Config.BACKOFFICE_EP_SUFFIX;

    constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-review-reply-history/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-review-reply-history/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
    }
}